import { Box } from '@mui/material'
import Profile from './Profile'
import { AdminSearch } from './AdminSearch'
import { useAuthContext } from 'components/context/AuthProvider'

export const AdminProfile = () => {
  const { isAdmin } = useAuthContext()

  return (
    <Box display="flex" flexGrow={1} justifyContent="flex-end" alignItems="center">
      {isAdmin ? <AdminSearch /> : null}
      <Profile />
    </Box>
  )
}
